<div class="bookingContent__cont">
  <div class="bookingContent__body">
    <ng-container *ngIf="isMobile">
      <ng-container *ngTemplateOutlet="resume"></ng-container>
    </ng-container>
    <form *ngIf="user" [formGroup]="bookingActivitiesForm" class="bookingContent__form">
      <section class="bookingContent__form-pax">
        <div class="bookingContent__form-pax-header">
          <app-ds-typography
            [tag]="'h1'"
            [size]="fontSize.XS"
            [color]="fontColor.Primary"
            [fontFamily]="fontFamily.SemiBold"
            [text]="(!isPerService ? 'PASSENGERS' : 'RESERVATION_INFO') | transloco">
          </app-ds-typography>
          <div class="bookingContent__form-pax-header-description">
            <app-ds-typography
              [tag]="'h3'"
              [size]="fontSize.XXS"
              [color]="fontColor.Secondary"
              [fontFamily]="fontFamily.Regular"
              [text]="(!isPerService ? 'BOOKING_MODULE.PAX.GENERAL_DESCRIPTION' : 'BOOKING_MODULE.PAX.RESERVATION_INFO_DESCRIPTION') | transloco">
            </app-ds-typography>
          </div>
        </div>
        <ng-container *ngFor="let passengerUI of passengerListUI$ | async; index as i">
          <app-pax-section
            [validator]="validation"
            [countries]="countries$ | async | countriesVm"
            [travelerType]="passengerUI.TravelerType"
            [listUILength]="passengerListUILength$ | async"
            [travelerInfoType]="travelerType"
            [paxTravelers]="travelers$ | async | travelerListVm : passengerUI.TravelerType : passengerUII(i) : startDate | async"
            [ordinalKey]="passengerUI.LinealOrdinalKey"
            [defaultData]="passengerUI.defaultData"
            [form]="bookingActivitiesForm"
            [user]="user"
            [isSubmittedSuccess]="isSubmittedSuccess"
            [isSubmitted]="isSubmitted"
            [travelerNumber]="i"
            [isMobile]="isMobile"
            [travelerBookingProvider]="travelerBookingProvider"
            [businessRules]="businessRules$ | async"
            [isAnInternationalTrip]="isAnInternationalTrip$ | async"
            (selectPax)="selectTravelerPax($event, i)"
            (removePax)="deleteTravelerPax($event, i)"
            (createPax)="createTravelerPax($event, bookingActivitiesForm, { id: i, TravelerInfoType: passengerUI.TravelerInfoType }, startDate)"
            (updatePax)="updateTravelerPax($event, bookingActivitiesForm, { id: i, TravelerInfoType: passengerUI.TravelerInfoType })"
            (amplitudeEvent)="trackBookingAmplitudeEvent($event, travelerBookingProvider)">
          </app-pax-section>
        </ng-container>
      </section>
      <ng-container *ngIf="paxSectionReady">
        <ng-container *ngIf="extraInformation$ | async as extraInformation">
          <section class="bookingContent__form-questions" *ngIf="extraInformation.length" #sectionExtraQuestionsRef>
            <div class="bookingContent__form-questions-header">
              <app-ds-typography
                [tag]="'h1'"
                [size]="fontSize.XS"
                [color]="fontColor.Primary"
                [fontFamily]="fontFamily.SemiBold"
                [text]="'BOOKING_MODULE.ADDITIONAL_INFORMATION.TITLE' | transloco">
              </app-ds-typography>
              <div class="bookingContent__form-questions-header-description">
                <app-ds-typography
                  [tag]="'h3'"
                  [size]="fontSize.XXS"
                  [color]="fontColor.Secondary"
                  [fontFamily]="fontFamily.Regular"
                  [text]="'BOOKING_MODULE.ADDITIONAL_INFORMATION.SUBTITLE' | transloco">
                </app-ds-typography>
              </div>
            </div>
            <app-extra-information
              [validation]="validation"
              [isSubmitted]="isSubmitted"
              [extraInformationVM]="extraInformation"
              [bookingForm]="bookingActivitiesForm"
              [isMobile]="isMobile">
            </app-extra-information>
          </section>
        </ng-container>
        <ng-container *ngIf="activeBillingModule" #sectionBillingRef>
          <ng-container *ngTemplateOutlet="billingCont"></ng-container>
        </ng-container>
        <section class="bookingContent__form-contact" #sectionContactDetails>
          <app-contact-section
            [form]="bookingActivitiesForm"
            [isSubmitted]="isSubmitted"
            [isMobile]="isMobile"
            [user]="user">
          </app-contact-section>
        </section>
        <section class="bookingContent__form-policies">
          <app-policies-detail
            [policiesType]="policiesType"
            [isMobile]="isMobile"
            [activitiesValidation]="validation"
            [showFreeCancellation]="false"
            [isBookingView]="true">
          </app-policies-detail>
        </section>
        <section class="bookingContent__form-payment" #sectionPaymentDetail *ngIf="isMobile">
          <ng-container *ngTemplateOutlet="paymentDetail"></ng-container>
        </section>
        <section class="bookingContent__form-terms" #sectionTermsRef>
          <app-terms-and-conditions
            [form]="bookingActivitiesForm"
            [isSubmitted]="isSubmitted"
            [policiesType]="policiesType">
          </app-terms-and-conditions>
        </section>
      </ng-container>
      <section class="bookingContent__form-rates" *ngIf="applyConversion$ | async">
        <app-exchange-rate-info 
          [conversionRate]="conversionRate$ | async">
        </app-exchange-rate-info>
      </section>
      <section class="bookingContent__form-support" *ngIf="activeCallSupportModule">
        <app-support-info></app-support-info>
      </section>
      <app-btn-go-to-pay
        [isMobile]="isMobile"
        [disabled]="(bookingReady$ | async) === false"
        [isLoadingBooking]="isLoadingBookingDelay"
        [applyConversion]="applyConversion$ | async"
        [conversionRate]="conversionRate$ | async"
        [finalPrice]="validation?.Products?.TotalPrice?.Total"
        [currencyCode]="validation?.Products?.TotalPrice?.CurrencyCode"
        [productReference]="validation?.ProductReference"
        (goToPay)="submitBookingOptions($event)">
      </app-btn-go-to-pay>
    </form>
    <ng-container *ngIf="!isMobile">
      <div class="bookingContent__right-resume">
        <div class="bookingContent__right-resume-wrapper">
          <ng-container *ngTemplateOutlet="paymentDetail; context: { modifier: 'wrapper' }"></ng-container>
          <ng-container *ngTemplateOutlet="resumeDetail"></ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #paymentDetail let-modifier="modifier">
  <div class="bookingContent__payment-cont bookingContent__payment-cont--{{modifier}}">
    <app-payment-detail
      [isActivities]="true"
      [price]="validation?.Products?.TotalPrice"
      [conversionRate]="conversionRate$ | async"
      [productReference]="validation?.ProductReference"
      [isMobile]="isMobile">
    </app-payment-detail>
  </div>
</ng-template>

<ng-template #resumeDetail>
  <div class="bookingContent__resume-cont">
    <app-ds-summary-card
      [type]="summaryCardType.Detailed"
      [options]="summaryOptions(true)"
      [image]="products?.[0]?.Images?.[0]"
      [title]="activityName">
    </app-ds-summary-card>
  </div>
</ng-template>

<ng-template #resume>
  <div class="bookingContent__resume">
    <app-ds-summary-card
      [type]="summaryCardType.Compacted"
      [options]="summaryOptions(false)"
      [header]="{
        Title: 'TOUR_AND_ACTIVITIES_MODULE.RESUME.YOUR_ACTIVITY' | transloco,
        Description: (startDate | date: 'EE, d MMM') | titlecase,
        Icon: icons.CivitatisFlat,
        Action: {
          Label: 'SEE_MORE' | transloco,
          Icon: icons.ChevronRight
        }
      }"
      [title]="activityName"
      (headerEvent)="goToDetail()">
    </app-ds-summary-card>
  </div>
</ng-template>

<ng-template #billingCont>
  <section class="bookingContent__form-billing">
    <ng-container *ngIf="billingModuleIsOptional; else billingModule">
      <ng-container *ngTemplateOutlet="optinalBilling"></ng-container>
    </ng-container>
  
    <ng-template #optinalBilling>
      <app-optional-billing-box
        [showBillingModule]="showBillingModule"
        (setShowBillingModule)="setShowBillingModule($event)">
      </app-optional-billing-box>
      <ng-container *ngTemplateOutlet="billingModule; context: { showHeaderInfo: true }"></ng-container>
    </ng-template>
    
    <ng-template #billingModule let-showHeaderInfo="showHeaderInfo">
      <ng-container *ngIf="showBillingModuleData">
        <app-billing
          [isSubmitted]="isSubmitted"
          [bookingForm]="bookingActivitiesForm"
          [countries]="countries$ | async | countriesVm"
          [cities]="cities$ | async"
          [user]="user"
          [isMobile]="isMobile"
          [showHeaderInfo]="!showHeaderInfo">
        </app-billing>
      </ng-container>
    </ng-template>
  </section>
</ng-template>

<router-outlet [name]="outletRoute"></router-outlet>